import {useGetData} from '../../src/apiservice/apiCall'


export function useSpeech(){
	return useGetData('/api/WebApi/GetSpeech')
}
